export const splitWords = (str: string) => str.replace(/([A-Z][a-z])/g, ' $1').replace(/(\d)/g, ' $1');
